import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledStack = styled(Stack)`
  /* border-bottom: 1px solid lightgray; */
  width: 100%;
`;
